/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneBreadcrumbs as ResolvedStandaloneBreadcrumbs } from 'base/components/standalone/Breadcrumbs';

export const Breadcrumbs: typeof ResolvedStandaloneBreadcrumbs = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneBreadcrumbs {...props} />
        </ErrorBoundary>
    );
});

export type BreadcrumbsProps = PropsFromComponent<typeof Breadcrumbs>;

/** @deprecated Use slot architecture instead */
export const BreadcrumbsWith = (extras: DynamicStandaloneExtras): typeof Breadcrumbs => {
    return function Breadcrumbs(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Breadcrumbs');
        return <ResolvedStandaloneBreadcrumbs {...mergeProps({ options: { theme } }, props)} />;
    }
}